import { lazy } from 'react';
import { PermissionsGuard } from './components';
import {
    CREATE_PERMISSION,
    READ_PERMISSION,
    STATUS_AUTH,
    UPDATE_PERMISSION,
} from 'src/constants/permissions';

export const Routes = [
    {
        exact: true,
        path: '/create/status/:id/substatus',
        guard: PermissionsGuard,
        roles: {
            permission: STATUS_AUTH,
            crud: CREATE_PERMISSION,
        },
        component: lazy(
            () => import('src/views/substatus/SubstatusCreateView')
        ),
    },
    {
        exact: true,
        path: '/management/substatus/:id',
        guard: PermissionsGuard,
        roles: {
            permission: STATUS_AUTH,
            crud: READ_PERMISSION,
        },
        component: lazy(
            () => import('src/views/substatus/SubstatusDetailsView')
        ),
    },
    {
        exact: true,
        path: '/management/substatus/:id/edit',
        guard: PermissionsGuard,
        roles: {
            permission: STATUS_AUTH,
            crud: UPDATE_PERMISSION,
        },
        component: lazy(() => import('src/views/substatus/SubstatusEditView')),
    },
];
